
  import { lazy } from "react";
  import routes from "./routesConfig/index";
  
  const PartnerPage = lazy(() => import("../Partner/PartnerPage"));
  const PartnerDetails = lazy(() => import("../Partner/partner-detail/PartnerDetail"));
  
  const partnerRoutes = [
    { path: routes.partner, component: PartnerPage, moduleKey: "partner", permissionKey: "partner_access" },
    { path: routes.PartnerDetail, component: PartnerDetails, moduleKey: "partner", permissionKey: "partner_access" },
  ];
  
  export default partnerRoutes;